import SetState from 'Components/Hooks/SetState'
import ButtonInsideBox from 'Components/UI/Atoms/ButtonInsideBox'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { getNavbar } from 'service/helpers/localstorage'

import Children from './ChildrenModal'

const FamilyAndProducts = () => {
  const { state, setOpen, setClose } = SetState()

  return (
    <>
      <ButtonInsideBox
        onClick={setOpen}
        text="Familias, productos y calidades"
        button="Configurar"
        img={process.env.PUBLIC_URL + '/Images/familyproducts.webp'}
        disabled={JSON.parse(getNavbar()).products ? false : true}
      />
      <DialogComponent
        open={state.open}
        title="Familias, productos y calidades"
        widthLarge="70vw"
        handleclose={setClose}
        disableBackdropClick
        disableEscapeKeyDown
        maxHeight
        children={<Children />}
      />
    </>
  )
}

export default FamilyAndProducts
